const AdGuruRoutes = {
  getAllAdbooks: "/admin/getallblogs",
  createAdbook: "/blog/blog",
  updateAdbook: "/blog/updateblogs"
}

export default AdGuruRoutes;